import React from 'react';
import { FocusResa } from './focusResa';
import { IntlProvider } from 'react-intl';
import { atom, useAtom, useAtomValue } from 'jotai';
import { Settings as LuxonSettings } from 'luxon';

export const __ = (str: string) => {
	return window.wp.i18n.__(str, FocusResa.getInstance().textDomain);
};

type Locale = 'fr' | 'en';
const locale: Locale = (() => {
	const l = document.documentElement.getAttribute('lang');
	if (l?.startsWith('fr')) return 'fr';
	return 'en';
})();
const intlLocaleAtom = atom<Locale | null>(locale);
const intlMessagesAtom = atom((get) => {
	const locale = get(intlLocaleAtom);
	if (locale == 'en')
		return import(`../../languages/focus-resa-en_GB.json`).then(
			(m) => m.default,
		);
	return import(`../../languages/focus-resa-fr_FR.json`).then((m) => m.default);
});

LuxonSettings.defaultLocale = locale;

export const antLocale = () => {
	if (locale == 'fr') return import('antd/locale/fr_FR').then((m) => m.default);
	return undefined;
};

export const I18nProvider = ({ children }: { children: React.ReactNode }) => {
	const [locale] = useAtom(intlLocaleAtom);
	const messages = useAtomValue(intlMessagesAtom);

	return (
		<IntlProvider locale={locale ?? ''} messages={messages}>
			{children}
		</IntlProvider>
	);
};
